import { FormInput, FormSelect } from "@/components";
import { COMMUNITY_NAME, METRIC_TYPE, METRIC_TYPE_OPTIONS, TYPE, YEAR } from "../consts";
import type { DistributionMetricsHeaderProps } from "../types";
import { actualTab, plannedTab, WEIGHING_FACTOR } from "@/lib/utils";

const Header = ({
  form,
}: DistributionMetricsHeaderProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-5">
        <FormInput
          name={COMMUNITY_NAME}
          control={form.control}
          label="Community"
          placeholder="Please enter"
          disabled
        />
        <FormInput
          name={YEAR}
          control={form.control}
          disabled
          label="Year"
          className="h-[42px]"
        />
        <FormSelect
          name={METRIC_TYPE}
          control={form.control}
          label="Metric Type"
          showSearch={false}
          placeholder="Please select"
          options={METRIC_TYPE_OPTIONS}
          className="h-[42px]"
        />
        {form.watch(METRIC_TYPE) == WEIGHING_FACTOR ? <FormSelect
          name={TYPE}
          control={form.control}
          label={"Type"}
          showSearch={false}
          options={[...plannedTab, ...actualTab]}
          placeholder="Please select"
          className="h-[42px]"
        /> : <></>}
    </div>
  );
};

export default Header;
